import React from "react";
import * as StateLib from "@/Utils/StateLib";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { useDirectorySearchContext } from "@/providers/DirectorySearchProvider";
import { useRightSidebarContext } from "@/providers/RightSidebarProvider";
import { checkDisconnected } from "../../Composites/SearchResult/SearchResult";
import TableResultsModal from "@/appComponents/Blocks/Modals/TableResultsModal/TableResultsModal";
import { QObjDBObject } from "@coreapp/CoreApp/QObjDBObject";
import { appstr } from "@coreapp/utils/appstr";

const DirectoryModal = ({ doc }) => {
  const nav = useAppNavigate();
  const { highlightRecord, handleSideBarModeChange } = useRightSidebarContext();
  const { dirSearchState, tableHandleRef, ResetColumnNames } = useDirectorySearchContext();
  const [data, setData] = React.useState([]);
  const [startPage, setStartPage] = React.useState(1);
  const directoryInfoLoadedRef = React.useRef(false);

  let wsMgr = StateLib.GetWSMgr();
  const eventTracker = wsMgr.GetUsageTracker();

  React.useEffect(() => {
    eventTracker.ReportEvent("directory_mode.view_mode.opened");
  }, []);

  React.useEffect(() => {
    // Reset column names only once when the directory info is loaded
    // Avoid future column resets when directory info was loaded, but new changes were detected
    if (!doc?.fDirectoryInfo || directoryInfoLoadedRef.current) {
      return;
    }
    ResetColumnNames();
    directoryInfoLoadedRef.current = true;
  }, [doc?.fDirectoryInfo]);

  React.useEffect(() => {
    let results = dirSearchState ? dirSearchState.results : [];
    // results are QObjDBObjects for custom charts
    if (!doc.IsServerChart()) {
      // iterate through QObjDBObjects and return JSON representation for table to ingest
      results = results
        .map(item => {
          if (item && item instanceof QObjDBObject) {
            let rowDataJSON = item.JSON();
            rowDataJSON.dbObjRef = item;
            return rowDataJSON;
          }
        })
        .filter(Boolean);
    }
    setData(results);
    setStartPage(1);
  }, [dirSearchState]);

  const handleRecordSelect = data => {
    let wsMgr = StateLib.GetWSMgr();
    let doc = StateLib.GetDoc();
    let recordId = "";

    if (data) {
      let recordIdFieldName = doc.GetRecordIDField().GetFieldName();
      recordId = data[recordIdFieldName];

      const canvasPanel = wsMgr.fCanvasPanel;
      canvasPanel.AddToInitialHighlight(recordId);

      let cmdElement = {};
      cmdElement["targetID"] = recordId;
      cmdElement["queryID"] = recordId;
      cmdElement["dbObjRef"] = data.dbObjRef;
      wsMgr.DoNavToBox(cmdElement, true, undefined, false, true);
    }

    if (!doc.IsServerChart() && checkDisconnected(data.dbObjRef)) {
      handleSideBarModeChange("staging");
      highlightRecord(data.dbObjRef);
      nav.setMode("edit");
    }

    StateLib.ReRenderCanvas();
  };

  return (
    <TableResultsModal
      tableData={data}
      tableHandleRef={tableHandleRef}
      tableColumnNames={dirSearchState.columnNames}
      onTableRowSelection={handleRecordSelect}
      startPage={startPage}
      dataTestIdPrefix={"directory-mode-"}
      caption={appstr("Directory")}
    />
  );
};

export default DirectoryModal;
